// useAuth hook - exports from AuthContext
import { useContext } from 'react';
import { useAuth as useAuthFromContext } from '@/contexts/AuthContext';

export const useAuth = () => {
    const context = useAuthFromContext();
    // Provide safe defaults if context is null
    if (!context) {
        return {
            user: null,
            session: null,
            loading: false,
            login: async () => ({ error: { message: 'AuthContext not available' } }),
            signup: async () => ({ error: { message: 'AuthContext not available' } }),
            logout: async () => { },
            isAuthenticated: false,
        };
    }
    return context;
};

export default useAuth;
